import { toast, Toast, ToastContainer } from "react-toastify";
import { CUSTOM_FIELD } from "constants";
import axios from "axios";
import configurations from "config";
const baseUrl = configurations.baseUrl;
const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;

export function handleErrors(error,t,navigate) {
   
    
    if (error.response.status == 403) {
        if (!error.response.data.message)
            toast.error(error.response.statusText);
        else {

            toast.error(t("userSessionValidationFailed"));
           
            localStorage.clear();
           
            const redirectTimeout = setTimeout(() => {
                clearTimeout(redirectTimeout);
                navigate("/vendor/login");
              }, 3000);

        }
    }
    else if (error.response.status == 500) {
        if (!error.response.data.message)
            toast.error(error.response.statusText);
        else 
            toast.error(t("internalServerError"));
    }
    else {
        toast.error(error.message);
    }
}

export const dateTimeFormat = (dateTimeString=null) => {
 
    if(dateTimeString)
    {
     const dateObject = new Date(dateTimeString);// Get the date in YYYY-MM-DD format
     const dateOnly = dateObject.toISOString().split('T')[0];
     const hours = dateObject.getHours();
     const minutes = dateObject.getMinutes();
     const seconds = dateObject.getSeconds();
     const timeOnly = `${hours}:${minutes}:${seconds}`; // Create a time string in "h:m:s" format
     return dateOnly + " " + timeOnly;
    } 
    else
    return null;
   }



export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};



export const manipulateDataForDefaultSelected = (nodes, collectionIds, currentParentId = 0) => {
    nodes.forEach((node) => {
      if (collectionIds.includes(node.value))
        selectNodeWithParents(nodes, node);
      else
        deselectNodeWithChildren(node);

      if (node.children && node.children.length > 0) {
        manipulateDataForDefaultSelected(node.children, collectionIds, node.value);
        if (node.children.some((child) => child.checked)) {
          selectNodeWithParents(nodes, node);
        }
      }
    });
  };

  const selectNodeWithParents = (nodes, node) => {
    node.checked = true;
    node.partialChecked = true;
    node.expanded = true;
    if (node.parent !== 0) {
      const parentNode = findNodeById(nodes, node.parent);
      if (parentNode) {
        selectNodeWithParents(nodes, parentNode);
      }
    }
  };

  const deselectNodeWithChildren = (node) => {
    node.checked = false;
    node.partialChecked = false;
    node.expanded = false;
    if (node.children && node.children.length > 0) {
      for (const child of node.children) {
        deselectNodeWithChildren(child);
      }
    }
  };

  const findNodeById = (nodes, id) => {
    for (const node of nodes) {
      if (node.value === id) {
        return node;
      }
      if (node.children && node.children.length > 0) {
        const foundNode = findNodeById(node.children, id);
        if (foundNode) {
          return foundNode;
        }
      }
    }
    return null;
  };

  export const formatAmountWithRupeeSymbol = (amount)=> {
    if (typeof amount !== 'number' || isNaN(amount)) {
      return '';
    }
    const formattedAmount = amount.toLocaleString('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  
    return formattedAmount;
  }

  export const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
  
    return result;
  };

  
  export const convertToTree = (data) => {
    const map = {};
    let x = [];
    const treeData = [];
    data.forEach((node) => {
      if (node.children.length == 0) {
        let tempArrayNew = {};
        tempArrayNew.label = node.name;
        tempArrayNew.value = node.id;
        treeData.push(tempArrayNew);
      }
      else {
        let tempArrayNew = {};
        tempArrayNew.label = node.name;
        tempArrayNew.value = node.id;
        tempArrayNew.children = convertToTree(node.children);
        tempArrayNew.parent = node.parentId;
        treeData.push(tempArrayNew);
      }
    });
    return treeData;
  };

  export const processCustomFields = (customFields, selectedCustomMultiselect, getValues) => {
    return customFields.map((item) => {
        if (item.fieldType !== CUSTOM_FIELD.FILE) {
            const id = item.id;
            let value;
  
            if (item.fieldType === CUSTOM_FIELD.MULTISELECT) {
                value = selectedCustomMultiselect[item.fieldName];
            } else {
                value = getValues(item.fieldName);
            }
  
            return {
                id: id,
                value: value,
            };
        } else {
            return {
                id: item.id,
                value: item.fileData ? item.fileData : item.value,
                fileType: item.fileType,
                azureId: item.azureId,
            };
        }
    });
  };

export const handleSkuExist = async (sku, variantId = 0, setIsLoading, t, navigate, variantsList = {}) => {
  if (sku && sku.length > 3 && sku.length < 17) {

    let skuExist = 0;
    if (variantsList && variantsList.length) {
      const skuExistsArray = variantsList.map(variant => variant.sku !== null && variant.sku === sku);
      if (skuExistsArray.includes(true)) {
        toast.error(t("sameSkuValueExistsForAnotherItem"));
        skuExist = 1;
      }
    }

    if (skuExist == 0) {
      let inputData = { sku: sku, variantId: variantId };
      setIsLoading(true);
      axios.post(baseUrl + "/product/check-product-sku-unique", inputData, {
        headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey },
      }).then((response) => {
        setIsLoading(false);
        toast.dismiss();
        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            if (response.data.data.skuAvailable == 0) {
              if (message != '') {
                toast.error(t(message))
              }
            }
          }
        }
        else {
          toast.error(t('unableToProccessRequest'));
        }
      })
        .catch(error => {
          setIsLoading(false);
          handleErrors(error, t, navigate);
        });
    }

  }
}
